export const formatDate = (datestring: string, localeCode?: string) => {
  if (!datestring) return "";
  try {
    const date = new Date(datestring);
    return localeCode === "enUS"
      ? [
          ("0" + (date.getMonth() + 1)).slice(-2),
          ("0" + date.getDate()).slice(-2),
          date.getFullYear(),
        ].join("/")
      : [
          ("0" + date.getDate()).slice(-2),
          ("0" + (date.getMonth() + 1)).slice(-2),
          date.getFullYear(),
        ].join("/");
  } catch (err) {
    return "";
  }
};

export const formatDateToIso = (date: Date | string) => {
  return new Date(date).toISOString().slice(0, 10);
};

export const isValidDate = (date?: string | Date | null) => {
  //@ts-expect-error new Date(date) can return "Invalid Date"
  return date && new Date(date) !== "Invalid Date" && !isNaN(new Date(date));
};
